// MediaSourceWrapper.js
import { connect } from 'react-redux';

import fetchBlurredResourceUrl from '../action/fetchBlurredResourceUrl.js';
import getMessageData from '../selector/getMessageData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import { formatSource, blurredAssetTypes } from '../resource/playerUtils.js';

import MediaSourceWrapper from '../component/MediaSourceWrapper.jsx';

const mapStateToProps = (state, { source, messageId }) => {
  const sources = formatSource({
    dash: source.dash,
    hls: source.hls,
  });
  const blurredAssetType = blurredAssetTypes[sources[0]?.typeKey];
  return {
    sources,
    blurredAssetType,
    contentUrl: getMessageData(state, messageId, blurredAssetType),
    isContentUrlFetching: getNetworkingData(
      state,
      ['messages', messageId, blurredAssetType],
      'isFetching'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchBlurredResourceUrl: data => dispatch(fetchBlurredResourceUrl(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MediaSourceWrapper);
